module.exports = __webpack_public_path__ + "logo-header.png?e24f4268e56b61210c0fc51238796750";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-header.png
// module id = 223
// module chunks = 0